module.exports = __webpack_public_path__ + "media/images/guadeloupe-88fba4b96db87e1a2fbf333d3740680e.svg";